<template>
  <div>
    <a-row>
      <a-col :span="24">
        <center>
          <a-avatar :size="100" style="font-size:20px !important;background: #B4ABDC">U</a-avatar>
          <span class="avatar--action">
            <a-icon type="edit"/>
          </span>
        </center>
      </a-col>

      <a-col class="mt-4 pl-2" :span="24">
        <a-row></a-row>
        <a-row>
          <a-form :form="form" @submit="updateProfile">
            <a-col :span="24">
              <span class="text-bold">BASIC INFORMATION</span>
            </a-col>
            <a-col class="mt-2" :span="24">
              <a-row>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">First Name</h4>
                    <a-input
                      v-decorator="['first_name', { initialValue: user.first_name,rules: [{ required: true, message: 'Please  enter your first name' }] }]"
                      class="custom-input"
                      placeholder="Plelase enter your last Name"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">Last Name</h4>
                    <a-input
                      v-decorator="['last_name', { initialValue: user.last_name,rules: [{ required: true, message: 'Please enter your last name' }] }]"
                      class="custom-input"
                      placeholder="Please enter your last Name"
                    />
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">Email Address</h4>
                    <a-input
                      v-decorator="['email', { initialValue: user.email, rules: [{ required: true, message: 'Please enter your email address' }] }]"
                      class="custom-input"
                      disabled
                      placeholder="Please enter your email Address"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">Contact Phone</h4>
                    <a-input
                      v-decorator="['phone', { initialValue: user.phone_number, rules: [{ required: true, message: 'Please enter your phone number' }] }]"
                      class="custom-input"
                      placeholder="Please enter your phone number"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">Username</h4>
                    <a-input
                      v-decorator="['username', {initialValue: user.username, rules: [{ required: true, message: 'Please enter a username' }] }]"
                      class="custom-input"
                      placeholder="What is the Name of this User"
                    />
                    <h5>
                      <ul class="custom-tags">
                        <li class="custom-tags--suggested text-opacity">Suggested:</li>
                        <li class="custom-tags--suggested text-colored">
                          <span>Obodugo.Rapheal,</span>
                        </li>
                        <li class="custom-tags--suggested text-colored">
                          <span>Kofacts,</span>
                        </li>
                        <li class="custom-tags--suggested text-colored">
                          <span>Obong,</span>
                        </li>
                      </ul>
                    </h5>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">
                      Fax
                      <sup>optional</sup>
                    </h4>
                    <a-input
                      v-decorator="['fax', { initialValue: user.fax }]"
                      class="custom-input"
                      type="number"
                      placeholder="What is your fax address"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>

            <a-col class="mt-2" :span="24">
              <span class="text-bold">LOCATION INFORMATION</span>
            </a-col>
            <a-col class="mt-2" :span="24">
              <a-row>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">Country of Residence</h4>
                    <a-select
                      showSearch
                      placeholder="Please select your country"
                      v-decorator="['country', {initialValue: user.country_d && user.country_d.name, rules: [{ required: true, message: 'Please select a country' }] }]"
                      @change="setCountry"
                    >
                      <a-select-option
                        :key="index"
                        :value="country.name"
                        v-for="(country,index) in countries"
                      >{{country.name}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">State of Residence</h4>
                    <a-select
                      showSearch
                      placeholder="Please select your state"
                      v-decorator="['state', {initialValue: user.state_d && user.state_d.name, rules: [{ required: true, message: 'Please select a state' }] }]"
                      @change="setState"
                    >
                      <a-select-option
                        :key="index"
                        :value="state.name"
                        v-for="(state,index) in states"
                      >{{state.name}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">City of Residence</h4>
                    <a-select
                      showSearch
                      placeholder="Please select your city"
                      v-decorator="['city', {initialValue: user.city_d && user.city_d.name, rules: [{ required: true, message: 'Please select a city' }] }]"
                    >
                      <a-select-option
                        :key="index"
                        :value="city.name"
                        v-for="(city,index) in cities"
                      >{{city.name}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item class="mr-2">
                    <h4 class="text-opacity">ZipCode</h4>
                    <a-input
                      v-decorator="['zipcode', {initialValue: user.zip_postal_code, rules: [{ required: true, message: 'Please enter a zipcode' }] }]"
                      class="custom-input"
                      placeholder="What is your state ZipCode"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item>
                    <h4 class="text-opacity">Address</h4>
                    <a-textarea
                      v-decorator="['address', {initialValue: user.street_address, rules: [{ required: true, message: 'Please enter an address' }] }]"
                      placeholder="What is your Address"
                      :autosize="{ minRows: 2, maxRows: 12 }"
                    />
                  </a-form-item>
                </a-col>
                <a-col class="mt-2" :span="24">
                  <button
                    style="float:right; padding-left:15px; padding-right:15px"
                    class="btn btn-primary"
                  >Update Profile</button>
                </a-col>
              </a-row>
            </a-col>
          </a-form>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { setTimeout } from "timers";

export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      actionStatus: "default",
      location: {
        selected_country: "",
        selected_state: ""
      }
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    countries() {
      return this.$store.getters.countries;
    },
    states() {
      if (this.location.selected_country !== "") {
        return this.$store.getters.states.filter(
          s => s.country_id === this.location.selected_country
        );
      } else {
        if (this.user.country_d) {
          return this.$store.getters.states.filter(
            s => s.country_id === this.user.country_d.id
          );
        }
        return this.$store.getters.states;
      }
    },
    cities() {
      if (this.location.selected_state !== "") {
        return this.$store.getters.cities.filter(
          s => s.state_id === this.location.selected_state
        );
      } else {
        if (this.user.state_d) {
          return this.$store.getters.cities.filter(
            s => s.state_id === this.user.state_d.id
          );
        }
        return this.$store.getters.cities;
      }
    }
  },
  methods: {
    setCountry(e) {
      //set the states to empty
      this.form.setFieldsValue({
        state: "",
        city: ""
      });
      this.location.selected_country = this.countries.find(
        s => s.name === e
      ).id;
    },
    setState(e) {
      this.form.setFieldsValue({
        city: ""
      });
      this.location.selected_state = this.states.find(s => s.name === e).id;
    },
    updateProfile(e) {
      e.preventDefault();
      const hide = this.$message.loading(
        "Updating your Profile - Please hold on a minute"
      );
      let user = this.$auth.user().id;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          let data = {
            id: this.user.id,
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            username: values.username,
            phone_number: values.phone,
            zip_postal_code: values.zipcode,
            country: this.countries.find(s => s.name === values.country).id,
            state: this.$store.getters.states.find(s => s.name === values.state).id,
            city: this.$store.getters.cities.find(s => s.name === values.city).id,
            fax: values.fax,
            street_address: values.address
          };
          this.$store
            .dispatch("updateProfile", data)
            .then(s => {
              if (s) {
                setTimeout(hide, 20);
                if (s.success) {
                  this.$message.success("⚡️⚡️" + s.message, 2.5);
                }
              }
            })
            .catch(err => {
              if (err.status === 422) {
                setTimeout(hide, 20);
                Object.values(err.data).forEach(s => {
                  this.$message.error("Sorry, " + s, 2.5);
                });
              }
            });
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("getCountries");
    this.$store.dispatch("getStates");
    this.$store.dispatch("getCities");
  }
};
</script>
